import React from "react";

import { hex2rgba, parseGuid } from "../../Helpers/parse";
import { GlobalContext } from "../../Context/GlobalContext";
import axios from "axios";

const ScheduleItem = ({
  item,
  color,
  schedule_metadata,
  setFile,
  webScheduleLive,
  webSchedulePrimary,
  webScheduleSecondary,
  webScheduleAvailable,
}) => {
  const { darkMode } = React.useContext(GlobalContext);
  let [state, setState] = React.useState({ file: null });
  const mountedRef = React.useRef(null);

  React.useEffect(() => {
    const load_file = async () => {
      if(item.guid) {
        let { data } = await axios.get(
          `https://qcga42i4k9.execute-api.us-west-2.amazonaws.com/${parseGuid(
            item.guid
          )}`
        );
        if(mountedRef.current) {
          setState({ file: data });
        }
      }
    };
    load_file();
  }, [item]);

  let description = state?.file?.metadata?.description || schedule_metadata[item.guid]?.description || ""
  return (
    <li
      className={"list-group-item sched-item-selected "}
      ref={mountedRef}
      style={{
        backgroundColor:
          new Date().getTime() >= item["start unix"] * 1000 &&
          new Date().getTime() <= item["end unix"] * 1000 && !darkMode
            ? color
                ? webScheduleLive
                    ? darkMode ? '#FFFFFF' : hex2rgba(webScheduleLive, 0.08)
                    : hex2rgba(color, 0.08)
                : '#FFFFFF'
              : state.file
              ? webScheduleAvailable
                ? darkMode ? '#FFFFFF' : hex2rgba(webScheduleAvailable, 0.08)
                : '#FFFFFF'
              : darkMode ? '#FFFFFF' : webScheduleSecondary
            ? hex2rgba(webScheduleSecondary, 0.08)
            : '#FFFFFF',
        borderColor:
          new Date().getTime() >= item["start unix"] * 1000 &&
          new Date().getTime() <= item["end unix"] * 1000
            ? color
              ? webScheduleLive
                ? hex2rgba(webScheduleLive, 0.4)
                : hex2rgba(color, 0.4)
              : ""
            : state.file
            ? webScheduleAvailable
              ? hex2rgba(webScheduleAvailable, 0.4)
              : hex2rgba(color, 0.4)
            : webScheduleSecondary
            ? hex2rgba(webScheduleSecondary, 0.4)
            : ""
      }}
      onClick={() => {
        console.log(item);
      }}
    >
      <div className="row">
        <div
          className="col"
          style={{
            color:
              new Date().getTime() >= item["start unix"] * 1000 &&
              new Date().getTime() <= item["end unix"] * 1000
                ? webScheduleLive
                  ? webScheduleLive
                  : color
                : state.file
                ? webScheduleAvailable
                  ? webScheduleAvailable
                  : "#000000"
                : webScheduleSecondary
                ? webScheduleSecondary : '#000000',
          }}
        >
          <div>
            <strong>
              {new Date(item.start).toLocaleString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </strong>{" "}
            {state.file && state.file.metadata
              ? state.file.metadata.filename
              : schedule_metadata[item.guid] && schedule_metadata[item.guid].title
              ? schedule_metadata[item.guid].title
              : item.item.split("/")[item.item.split("/").length - 1]}
          </div>
          <div>
            {description}
          </div>
        </div>
        <div
          style={{
            color:
              new Date().getTime() >= item["start unix"] * 1000 &&
              new Date().getTime() <= item["end unix"] * 1000
                ? webScheduleLive
                  ? webScheduleLive
                  : color
                : state.file
                ? webScheduleAvailable
                  ? hex2rgba(webScheduleAvailable, 0.08)
                  : "#000000"
                : "#000000",
          }}
        >
          <strong>
            {new Date().getTime() >= item["start unix"] * 1000 &&
            new Date().getTime() <= item["end unix"] * 1000
              ? "Live"
              : ""}
          </strong>
          {state.file &&
          !(
            new Date().getTime() >= item["start unix"] * 1000 &&
            new Date().getTime() <= item["end unix"] * 1000
          ) ? (
            // <i
            //   className="fas fa-play-circle"
            //   style={{ color }}
            //   onClick={() => {
            //     setFile(state.file);
            //   }}
            // ></i>
            <div
              className="sched-play"
              onClick={() => {
                setFile(state.file);
              }}
              style={{
                borderColor: webScheduleAvailable
                  ? hex2rgba(webScheduleAvailable, 0.4)
                  : color
                  ? hex2rgba(color, 0.4)
                  : "",
                backgroundColor: webScheduleAvailable
                  ? hex2rgba(webScheduleAvailable, 0.08)
                  : color
                  ? hex2rgba(color, 0.4)
                  : "#FFFFFF",
                color: webScheduleAvailable ? webScheduleAvailable : color,
              }}
            >
              Watch Now!
            </div>
          ) : (
            []
          )}
        </div>
      </div>
    </li>
  );
};

export default ScheduleItem;
